module.exports = __webpack_public_path__ + "static/img/banner1.c17be0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site-image/banner1.jpg
// module id = JdQY
// module chunks = 169